import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=62b5f749&scoped=true&"
import script from "./Link.vue?vue&type=script&lang=ts&"
export * from "./Link.vue?vue&type=script&lang=ts&"
import style0 from "./Link.vue?vue&type=style&index=0&id=62b5f749&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b5f749",
  null
  
)

export default component.exports